import { render, staticRenderFns } from "./myCase.vue?vue&type=template&id=37d69ab6&scoped=true&"
import script from "./myCase.vue?vue&type=script&lang=js&"
export * from "./myCase.vue?vue&type=script&lang=js&"
import style0 from "./myCase.vue?vue&type=style&index=0&id=37d69ab6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d69ab6",
  null
  
)

export default component.exports